import _sfc_main from "./form-item-message.vue_vue&type=script&lang.js";
import { openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, Transition, withCtx, createElementVNode, createTextVNode, toDisplayString } from "vue";
import _export_sfc from "../_virtual/plugin-vue_export-helper";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.isHelp ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(_ctx.cls)
  }, [
    renderSlot(_ctx.$slots, "default")
  ], 2)) : (openBlock(), createBlock(Transition, {
    key: 1,
    name: "form-blink",
    appear: ""
  }, {
    default: withCtx(() => [
      createElementVNode("div", {
        class: normalizeClass(_ctx.cls)
      }, [
        renderSlot(_ctx.$slots, "default", {}, () => [
          createTextVNode(toDisplayString(_ctx.error), 1)
        ])
      ], 2)
    ]),
    _: 3
  }));
}
var FormItemMessage = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { FormItemMessage as default };
